import sdl from '@jds/react-generated-sdl/JDSInput';
import type { JDSInputProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSInputProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    disabled = false,
    type = 'text',
    textAlign = 'start',
    textSize = 'small',
    ariaRequired = props.required?.toString(),
    ariaPlaceholder = props.placeholder?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      disabled,
      type,
      textAlign,
      textSize,
      ariaRequired,
      ariaPlaceholder,
      ...rest
    },
    'JDSInput',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Input = withLogic(Component) as React.FC<JDSInputProps> & {
  slotName?: string;
};

Input.displayName = 'Input';
Input.slotName = 'jds_input';

export { Input, type JDSInputProps };
